var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.507,
    height: 10.178,
    viewBox: "0 0 11.507 10.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sortIcon",
    transform: "translate(-867.728 230.361) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12828",
    "data-name": "Group 12828",
    transform: "translate(220.869 868.07)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_550",
    "data-name": "Line 550",
    x2: 8.806,
    transform: "translate(0 1.911)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098",
    "data-name": "Path 11098",
    d: "M240.885,869.657l1.8-1.911-1.8-1.911",
    transform: "translate(-233.876 -865.835)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12829",
    "data-name": "Group 12829",
    transform: "translate(220.869 875.07)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_550-2",
    "data-name": "Line 550",
    x1: 8.806,
    transform: "translate(0 1.911)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11098-2",
    "data-name": "Path 11098",
    d: "M242.682,869.657l-1.8-1.911,1.8-1.911",
    transform: "translate(-240.885 -865.835)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sortIcon.95839225338b58c3e139bd4aa1c2a1fc.svg";
export { ForwardRef as ReactComponent };